module.exports = __webpack_public_path__ + "static/media/ecomlogo.f2632168.png";